import { Transition } from '@headlessui/react'
import { XCircleIcon } from '@heroicons/react/solid'
import React, { useState } from 'react'
import ClickAwayListener from 'react-click-away-listener'
import SvgJadvalVazni from 'shared/components/icon-pack/icons/JadvalVazni'

import Widgets from './weight-widgets'

function WeightedTable() {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const rotateClassName = 'rotate-90 text-[#5E5E81]'

  const handleClickAway = () => {
    setIsOpen(false)
  }

  return (
    <>
      <SvgJadvalVazni
        onClick={() => setIsOpen(true)}
        className={`w-6 h-6 text-[#8B8F9A] hover:text-[#F35225] cursor-pointer ${
          isOpen ? '!text-[#F35225]' : ''
        }`}
      />
      <Transition
        show={isOpen}
        enter="transition-opacity duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <ClickAwayListener onClickAway={handleClickAway}>
          <div className="fixed left-[70px] flex flex-col items-center top-20 z-40 rounded-2 w-[241px] min-h-[12px] bg-[#2E2E48]">
            <div className="flex ">
              <span className={rotateClassName}>-</span>
              <span className={rotateClassName}>-</span>
              <span className={rotateClassName}>-</span>
              <span className={rotateClassName}>-</span>
              <span className={rotateClassName}>-</span>{' '}
              <span className={rotateClassName}>-</span>{' '}
              <span className={rotateClassName}>-</span>{' '}
              <span className={rotateClassName}>-</span>{' '}
              <span className={rotateClassName}>-</span>
            </div>
            <XCircleIcon
              className="w-[16.67px] h-[16.67px] ml-48 -mt-2 text-[#7E92A2] cursor-pointer"
              onClick={() => setIsOpen(false)}
            />
            <span className="font-normal text-2.5 leading-6 -mt-3 text-[#7E92A2]">
              جدول وزنی
            </span>
            <div className="w-full px-4 min-h-[333px]">
              <Widgets />
            </div>
          </div>
        </ClickAwayListener>
      </Transition>
    </>
  )
}

export default WeightedTable
